import React from 'react';

const StocksAndBondsOwnerFilterIcon = (props: any) => (
  <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
    <path d="M4.5 17L4.5 15" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
    <path d="M10 11V9" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
    <path d="M15.5 15V13" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
    <path d="M4.5 11L4.5 9" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
    <path d="M10 5L10 3" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
    <path d="M15.5 9V7" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
    <path d="M6 11H3V15H6V11Z" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
    <path d="M11.5 5H8.5V9H11.5V5Z" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
    <path d="M17 9H14V13H17V9Z" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
  </svg>
);

export default StocksAndBondsOwnerFilterIcon;
